<main>
    <h2>{{ "MAIN_APP_PENDENZEN_AUFGABE.myTasks" | translate }}</h2>
    <mat-card class="card-margin" [class.bgColor]="checkDate(today, task.dueDate)" *ngFor="let task of taskLines">
      <div class="list-item-layout" *ngIf="innerWidth > 480">
        <div class="list-item-first-box">
              <mat-icon *ngIf="checkDate(today, task.dueDate)" class="color2">priority_high</mat-icon>
              <div class="black">{{task.dueDate | datumFormat}}</div>
        </div>
         <div class="list-box">
            <div>{{task.description}}</div>
         </div>
         <div class="list-box" (click)="showDetails(task)">
          <div class="link">{{ "MOBILE_APP.MY_APPOINTMENTS.DISPLAY_INFOS" | translate }}</div>
         </div>
         <div class="list-box flex-box">
          <button mat-mini-fab class="vinavonButton" (click)="showAufgabeDetail(task)">
            <mat-icon style="margin: 0;">edit</mat-icon>
          </button>
         </div>
      </div>

      
      <div class="list-item-layout-mobile" *ngIf="innerWidth <= 480">
        <div class="list-item-first-box-mobile">
            <mat-icon *ngIf="checkDate(today, task.dueDate)" class="color2">priority_high</mat-icon>
            <div class="black small-font">{{task.dueDate | datumFormat}}</div>
        </div>

        <div class="list-box-mobile">
          <div>{{task.description}}</div>
          <div class="link" (click)="showDetails(task)">{{ "MOBILE_APP.MY_APPOINTMENTS.DISPLAY_INFOS" | translate }}</div>
       </div>

       <div class="list-box flex-box">
        <button mat-mini-fab class="vinavonButton" (click)="showAufgabeDetail(task)">
          <mat-icon>edit</mat-icon>
        </button>
       </div>       
      </div>
    </mat-card>
</main>
